import React, { Component, useState } from "react";

class AgentCodeCheck extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isChecked: false,
    };
  }
  onChangeSwitch = () => {
    this.setState({isChecked: !this.state.isChecked},function(){
      this.props.sendData(this.state.isChecked);
     });
  };
  // const [isChecked, setIsChecked] = useState(false);

  // const handleOnChange = () => {
  //   setIsChecked(!isChecked);
  // };
  render() {
    return (
      <input
        type="checkbox"
        id="agentCode"
        name="agentCode"
        value="agentCode"
        style={{ height: "27px", width: "27px" }}
        checked={this.props.isChecked}
        // onChange={this.props.handleTriggerCheckbox}
        onChange={this.onChangeSwitch}
      />
    );
  }
}

export default AgentCodeCheck;
